<div
  class="start-puzzle"
  [ngClass]="layoutService.expandedMenu ? 'expand' : ''"
>
  <div class="title-bar-puzzles">
    <div class="container-fluid">
      <div class="d-flex justify-content-end">
        <a class="ml-4 m-sm-0 cursor" (click)="emitData('backToElearning')">
          <img src="assets/ph-bhp-layout/svg/remove.svg" alt="Imagen" />
        </a>
      </div>
      <div class="col-12 pt-3 m-0">
        <div class="row">
          <div
            class="col p-0 d-flex justify-content-between align-items-center start-puzzle-heading"
          >
            <div class="col-sm-6 col-auto title-and-description-puzzle">
              <h2 class="page-title">
                {{
                  layoutService.translateText(sopDetails.title) | labelSanitizer
                }}
              </h2>
              <p class="card-task-desc">
                {{
                  layoutService.translateText(sopDetails.description)
                    | labelSanitizer
                }}
              </p>
            </div>
            <div
              class="col-auto d-flex justify-content-between align-items-center counter-start-puzzle"
            >
              <div class="col-auto">
                <h5>{{ "E_LEARNING.BEST_SCORE" | translate }}</h5>
                <span>{{ bestScore }} </span>
              </div>
              <div class="col-auto">
                <h5>{{ "E_LEARNING.MOVE" | translate }}</h5>
                <span>{{ drag_counts }}</span>
              </div>
              <div class="col-auto">
                <h5>{{ "EVALUATION.STEPS" | translate }}</h5>
                <span>{{ completed_steps }}</span>
              </div>
              <div class="col-auto">
                <h5>{{ "E_LEARNING.TIME" | translate }}</h5>
                <span id="time">00:00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="container-fluid p-0"> -->
    <div class="puzzleContainer" cdkDropListGroup>
      <div class="col-auto example-container puzzleContainerLeft">
        <div class="shuffled-container fullHeight">
          <h2 class="card-task-title">
            {{ "E_LEARNING.SOP_STEPS" | translate }}
          </h2>
          <div class="puzzleCardList" >
            <div
              cdkDropList
              #shuffledList="cdkDropList"
              [cdkDropListData]="shuffledsteps"
              [cdkDropListConnectedTo]="IdList"
              class="example-list d-block"
              (cdkDropListDropped)="drop($event)"
            >
              <div
                [id]="item.stepId"
                class="example-box card_elearning mb-4"
                style="width: 233px"
                *ngFor="let item of shuffledsteps"
                cdkDrag
              >
                <div class="card-task_elearning">
                  <div
                    class="card-task-media_elearning d-flex justify-content-center align-items-center"
                  >
                    <img
                      [ngClass]="
                        item.stepCards[0].stepImage ? 'svg' : 'no-image'
                      "
                      [src]="
                        item.stepCards[0].stepImage
                          ? layoutService.serverUrl +
                            item.stepCards[0].stepImage
                          : 'assets/ph-bhp-layout/svg/no-image-bd.png'
                      "
                    />
                  </div>
                </div>
                <div class="card-task-content_elearning">
                  <div class="card-task-title" *ngIf="!item.stepType">
                    {{
                      item.stepCards[0].stepTittle
                        ? (item.stepCards[0].stepTittle
                          | translate
                          | labelSanitizer)
                        : ("SOP_MANAGEMENT.TEXT_HERE" | translate)
                    }}
                  </div>
                  <div class="card-task-title" *ngIf="item.stepType">
                    {{
                      item.stepName
                        ? (item.stepName | translate | labelSanitizer)
                        : ("SOP_MANAGEMENT.TEXT_HERE" | translate)
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col example-container puzzleContainerRight">
        <h2 class="col-12 card-task-title">
          {{ "E_LEARNING.DRAG_DROP_LEFT_RIGHT" | translate }}
        </h2>
        <div class="col-12 puzzleContainerRightList" >
          <div class="row m-0">
            <div
              *ngFor="let item1 of arrangedList; let j = index"
              class="col-auto pr-0 d-inline-flex"
            >
              <div
                cdkDropList
                [attr.id]="addId(j)"
                [cdkDropListData]="arrangedList[j]"
                [cdkDropListConnectedTo]="[shuffledList]"
                class="example-list"
                (cdkDropListDropped)="drop($event)"
              >
                <div
                  class="example-box card_elearning mb-4"
                  style="width: 233px"
                  cdkDragPreview
                >
                  <div class="container col-12">
                    <div class="row">
                      <div class="card-task_elearning_v2">
                        <div
                          class="card-task-media_elearning col-12 d-flex justify-content-center align-items-center"
                        >
                          <img
                            [ngClass]="item1[1].stepImage ? 'no-image' : 'svg'"
                            [src]="
                              item1[1].stepImage
                                ? 'assets/ph-bhp-layout/svg/no-image-bd.png'
                                : layoutService.serverUrl +
                                  item1[0].stepCards[0].stepImage
                            "
                          />
                        </div>
                      </div>
                      <div class="container col-12 card-task-content_elearning">
                        <div class="card-task-title">
                          {{
                            item1[2].stepTitle
                              ? ("E_LEARNING.STEP" | translate | labelSanitizer) + " " + (j + 1)
                              : (item1[0].stepCards[0].stepTittle
                                | translate
                                | labelSanitizer)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->
</div>

<ng-template #template>

  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ "E_LEARNING.RESULT" | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img
        src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body">
    <p class="lead">
      {{ "E_LEARNING.YOUR_SCORE" | translate }}
    </p>
    <p class="lead">
      {{ myScore }}
    </p>
    <p class="lead">
      {{ "E_LEARNING.BEST_SCORE" | translate }} {{ bestScore }}
    </p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="replayPuzzle(); modalRef.hide()" class="btn btn-continue-bordered-bd">{{ "E_LEARNING.REPLAY" | translate }}</button>
    </div>
  </div>
</ng-template>

<!--<div
  class="content-inner"
  [ngClass]="layoutService.expandedMenu ? 'expand' : ''"
  style="background-color: #f5f5f5"
>
  <div class="container-fluid p-0 col-11">
    <img class="svg" src="assets/ph-bhp-layout/svg/back.svg" />
    <h2 class="page-title">{{ "E_LEARNING.PUZZLE" | translate }}</h2>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-4">
        <div
          class="col-12"
          style="
            height: 100vh !important;
            margin: 40px;
            margin-left: 43px;
            background-color: #fff;
          "
        >
          <div >
            <div
              cdkDropList
              #shuffledList="cdkDropList"
              [cdkDropListData]="shuffledsteps"
              [cdkDropListConnectedTo]="IdList"
              (cdkDropListDropped)="drop($event)"
            >
              <div
                class="container col-12 card_elearning mb-2"
                *ngFor="let item of shuffledsteps"
                cdkDrag
              >
                <div class="row">
                  <div class="col-12 p-0 card-task_elearning">
                    <div class="mb-4">
                      <div class="card-task-media_elearning">
                        <img
                          [ngClass]="
                            item.stepCards[0].stepImage ? 'svg' : 'no-image'
                          "
                          [src]="
                            item.stepCards[0].stepImage
                              ? layoutService.serverUrl +
                                item.stepCards[0].stepImage
                              : 'assets/ph-bhp-layout/svg/no-image.png'
                          "
                        />
                      </div>
                    </div>
                  </div>

                  <div class="p-2 col-12 card-task-content_elearning">
                    <div class="col">
                      <div
                        class="mb-0 card-task-desc-puzzle"
                        *ngIf="!item.stepType"
                      >
                        {{
                          item.stepCards[0].stepTittle
                            ? (item.stepCards[0].stepTittle
                              | translate
                              | labelSanitizer)
                            : ("SOP_MANAGEMENT.TEXT_HERE" | translate)
                        }}
                      </div>
                      <div
                        class="mb-0 card-task-desc-puzzle"
                        *ngIf="item.stepType"
                      >
                        {{
                          item.stepName
                            ? (item.stepName | translate | labelSanitizer)
                            : ("SOP_MANAGEMENT.TEXT_HERE" | translate)
                        }}
                      </div>
                    </div>
                    <div class="col-12 d-flex justify-content-end">
                      <button type="button" class="btn btn-outline-primary">
                        Start
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
 
    </div>
  </div>
</div>
-->